export const BonusActionTypes = {
    SET_BONUSES: 'SET_BONUSES'
  }